export default __webpack_public_path__ + "static/media/interest-check.c1307344.svg";